// React import not needed - component returns null

/**
 * BlogHero - Featured Blog Post Section
 *
 * This component is temporarily hidden as per design requirements.
 * The featured post section will be enabled when blog content is ready.
 *
 * To re-enable: Remove the early return statement and uncomment the JSX below.
 */
const BlogHero = () => {
  // TEMPORARILY HIDDEN: Featured blog post section hidden on both mobile and desktop
  // Remove this return statement to re-enable the featured post section
  return null;

  /* COMMENTED OUT - Featured Post Section
  return (
    <div className="blog-hero-container">
      <div className="blog-featured-image">
        <div className="blog-featured-content">
          <div className="blog-featured-header">
            <div className="blog-featured-badge">
              <div className="blog-featured-title">Featured Post</div>
            </div>
            <div className="blog-featured-text">
              <div className="blog-featured-heading">
                Travel Smarter. Explore Deeper. Live Freer.
              </div>
              <div className="blog-featured-description">
                From packing lists and expert hacks to scenic routes and local
                secrets, our blog is here to help you get the most out of your
                campervan journey across Portugal. Whether you're a first-time
                van traveler or a seasoned road tripper, you'll find practical
                advice and travel inspiration for every kind of adventure.
              </div>
            </div>
          </div>
          <div className="blog-featured-divider"></div>
          <div className="blog-featured-meta">
            <div className="blog-meta-info">
              <div className="blog-meta-item">
                <div className="blog-meta-icon">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12 2.25C10.0716 2.25 8.18657 2.82183 6.58319 3.89317C4.97982 4.96451 3.73013 6.48726 2.99218 8.26884C2.25422 10.0504 2.06114 12.0108 2.43735 13.9021C2.81355 15.7934 3.74215 17.5307 5.10571 18.8943C6.46928 20.2579 8.20656 21.1865 10.0979 21.5627C11.9892 21.9389 13.9496 21.7458 15.7312 21.0078C17.5127 20.2699 19.0355 19.0202 20.1068 17.4168C21.1782 15.8134 21.75 13.9284 21.75 12C21.7473 9.41498 20.7192 6.93661 18.8913 5.10872C17.0634 3.28084 14.585 2.25273 12 2.25ZM12 20.25C10.3683 20.25 8.77326 19.7661 7.41655 18.8596C6.05984 17.9531 5.00242 16.6646 4.378 15.1571C3.75358 13.6496 3.5902 11.9908 3.90853 10.3905C4.22685 8.79016 5.01259 7.32015 6.16637 6.16637C7.32016 5.01259 8.79017 4.22685 10.3905 3.90852C11.9909 3.59019 13.6497 3.75357 15.1571 4.37799C16.6646 5.00242 17.9531 6.05984 18.8596 7.41655C19.7661 8.77325 20.25 10.3683 20.25 12C20.2475 14.1873 19.3775 16.2843 17.8309 17.8309C16.2843 19.3775 14.1873 20.2475 12 20.25ZM18 12C18 12.1989 17.921 12.3897 17.7803 12.5303C17.6397 12.671 17.4489 12.75 17.25 12.75H12C11.8011 12.75 11.6103 12.671 11.4697 12.5303C11.329 12.3897 11.25 12.1989 11.25 12V6.75C11.25 6.55109 11.329 6.36032 11.4697 6.21967C11.6103 6.07902 11.8011 6 12 6C12.1989 6 12.3897 6.07902 12.5303 6.21967C12.671 6.36032 12.75 6.55109 12.75 6.75V11.25H17.25C17.4489 11.25 17.6397 11.329 17.7803 11.4697C17.921 11.6103 18 11.8011 18 12Z"
                      fill="#009B31"
                    ></path>
                  </svg>
                </div>
                <div className="blog-meta-text">4 Min Read</div>
              </div>
              <div className="blog-meta-divider">
                <svg
                  width="2"
                  height="16"
                  viewBox="0 0 2 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0.499999 15.5C0.499999 15.7761 0.723857 16 0.999999 16C1.27614 16 1.5 15.7761 1.5 15.5L0.499999 15.5ZM1 0.5L0.5 0.5L0.499999 15.5L0.999999 15.5L1.5 15.5L1.5 0.5L1 0.5Z"
                    fill="white"
                    fillOpacity="0.1"
                  ></path>
                </svg>
              </div>
              <div className="blog-meta-item">
                <div className="blog-meta-icon">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M19.5 3H17.25V2.25C17.25 2.05109 17.171 1.86032 17.0303 1.71967C16.8897 1.57902 16.6989 1.5 16.5 1.5C16.3011 1.5 16.1103 1.57902 15.9697 1.71967C15.829 1.86032 15.75 2.05109 15.75 2.25V3H8.25V2.25C8.25 2.05109 8.17098 1.86032 8.03033 1.71967C7.88968 1.57902 7.69891 1.5 7.5 1.5C7.30109 1.5 7.11032 1.57902 6.96967 1.71967C6.82902 1.86032 6.75 2.05109 6.75 2.25V3H4.5C4.10218 3 3.72064 3.15804 3.43934 3.43934C3.15804 3.72064 3 4.10218 3 4.5V19.5C3 19.8978 3.15804 20.2794 3.43934 20.5607C3.72064 20.842 4.10218 21 4.5 21H19.5C19.8978 21 20.2794 20.842 20.5607 20.5607C20.842 20.2794 21 19.8978 21 19.5V4.5C21 4.10218 20.842 3.72064 20.5607 3.43934C20.2794 3.15804 19.8978 3 19.5 3ZM6.75 4.5V5.25C6.75 5.44891 6.82902 5.63968 6.96967 5.78033C7.11032 5.92098 7.30109 6 7.5 6C7.69891 6 7.88968 5.92098 8.03033 5.78033C8.17098 5.63968 8.25 5.44891 8.25 5.25V4.5H15.75V5.25C15.75 5.44891 15.829 5.63968 15.9697 5.78033C16.1103 5.92098 16.3011 6 16.5 6C16.6989 6 16.8897 5.92098 17.0303 5.78033C17.171 5.63968 17.25 5.44891 17.25 5.25V4.5H19.5V7.5H4.5V4.5H6.75ZM19.5 19.5H4.5V9H19.5V19.5Z"
                      fill="#009B31"
                    ></path>
                  </svg>
                </div>
                <div className="blog-meta-text">25 July</div>
              </div>
            </div>
            <div className="blog-read-more-button">
              <div className="blog-button-text">Read More</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
  */
};

export default BlogHero;
